import React from "react";
import { Nav } from "../commons/nav";
import { Loader } from "../commons/loader";
import { disableDiv } from "../../utils/helper";
import CourierTabs from "./courier-tabs";

export const CourierListHeadAction = ({ label, onClick }) => (
  <a
    href=" "
    className="order-btn"
    style={{ cursor: "pointer" }}
    onClick={e => {
      e.preventDefault();
      onClick();
    }}
  >
    {label}
  </a>
);

export const CourierListPage = ({
  title,
  count,
  countLabel = "results",
  loading,
  headActions,
  children
}) => (
  <div id="wrapper" className="inner-page">
    <Nav />
    <div className="listing-page courier-section" style={disableDiv(loading)}>
      <div className="listing-head">
        <h2>
          {title}{" "}
          {count != null && (
            <span className="small">
              - {count} {countLabel}
            </span>
          )}
        </h2>
        {headActions && (
          <div className="listing-head-actions">{headActions}</div>
        )}
      </div>
      <CourierTabs />
      {children}
      {loading && <Loader />}
    </div>
  </div>
);

export default CourierListPage;
